module.exports = global["Marionette"] = require("-!./backbone.marionette.js");


//////////////////
// WEBPACK FOOTER
// ../~/backbone.marionette/lib/core/backbone.marionette.js
// module id = 631
// module chunks = 0